export const GET_SELECTED_STUDENT_STATUS = 'GET_SELECTED_STUDENT_STATUS';